import { Users, TrendingUp, Calendar, Clock } from "lucide-react"
import Box from "../../components/Box"
import { MarktingCard } from "../AiMarketingTeam"

const cards = [
  {
    icon: <Users className="w-6 h-6" />,
    iconBg: "bg-indigo-100",
    iconColor: "text-blue-600",
    title: "Up to 1,00,000",
    description: "New parents reached",
    highlight: true
  },
  {
    icon: <TrendingUp className="w-6 h-6" />,
    iconBg: "bg-indigo-100",
    iconColor: "text-blue-600",
    title: "Up to ₹2.5 Cr",
    description: "In admissions growth",
    highlight: true
  },
  {
    icon: <Calendar className="w-6 h-6" />,
    iconBg: "bg-indigo-100",
    iconColor: "text-blue-600",
    title: "365 days",
    description: "Of daily brand presence",
    highlight: true
  }, {
    icon: <Clock className="w-6 h-6" />,
    iconBg: "bg-indigo-100",
    iconColor: "text-blue-600",
    title: "< 10 min",
    description: "To get started",
    highlight: true
  }
]

export default function WhatWeDeliver() {
  return (
    <Box
      badge={"WHAT WE DELIVER"}
      title={"The Results You'll See"}
      description={"When your school becomes visible, everything changes."}
      leftBlock={<div>
        <img
          src="/images/new-landing-page/theResultYouSee.png"
          alt="School building with students"
          className="w-full h-full object-cover rounded-3xl shadow-lg"
        />
      </div>}
      rightBlock={
        <div className="grid grid-cols-2 md:grid-cols-1 gap-6">
          {/* Stat Card 1 */}
          {cards?.map((item, index) => <MarktingCard key={"asdhadjhasdsad"+index} member={item} /> )}
        </div>
      }
    />
  )
}
